import { useEffect, useState } from 'react';
import {
  useGetSelectedStudentTable,
  useHandleSearchDistrictSchoolSelector,
  validateMoveStudentFormData as validator,
} from './MoveStudentsActionHooks';
import SearchAndSortableTable from '../../../../../../components/table/SearchAndSortableTable';
import DistrictSchoolSelector from '../../../../components/actions/district-school-selector/DistrictSchoolSelector';
import './MoveStudentsForm.scss';

export const validateMoveStudentFormData = validator;

const MoveStudentsForm = ({
  initData,
  studentTableData,
  onDataChange,
} = {
  initData: {
    schoolId: null,
  },
  studentTableData: [],
  onDataChange: () => null,
}) => {
  const {
    tableConfig,
    tableData,
  } = useGetSelectedStudentTable({
    studentTableData,
  });

  const [data, setData] = useState({ ...initData });

  useEffect(() => {
    setData({ ...initData });
  }, [initData]);

  const {
    handleOnDistrictSchoolChange,
  } = useHandleSearchDistrictSchoolSelector({
    data,
    setData,
    onDataChange,
  });

  return (
    <div className='move-student-form'>
      <SearchAndSortableTable
        containerClassName='move-student-table'
        config={tableConfig}
        tableData={tableData}
        initTableState={{
          order: 'desc',
          orderBy: 'userName',
        }}
        autoResetTableState
        filterable={false}
        rowsPerPageOptions={[5, 10, 25, 50]}
      />

      <DistrictSchoolSelector
        onChange={handleOnDistrictSchoolChange}
        selectedDistrictId={data.district && data.district.key}
        selectedSchoolId={data.school && data.school.key}
      />
    </div>
  );
};

export default MoveStudentsForm;
